import React, { ChangeEvent, useState } from "react";
import Paginator from "../../../../components/Pagination/Pagination.component";
import useCustomerWalletTransactions from "../../../../custom-hooks/useCustomerWalletTransactions";
import { formatMoney } from "../../../../helpers/formatter";
import Loader from "../../../../NewComponents/Loader/Loader.component";
import NoTableDataAvailable from "../../../../NewComponents/NoTableDataAvailable/NoTableDataAvailable.component";
import moment from "moment";

const CustomerWalletTransactions = ({ walletDetails }: any) => {
  const { accountNumber, walletProvider } = walletDetails;
  const [preState, setPreState] = useState({
    pageNumber: 1,
    size: 20,
    accountNumber: accountNumber,
    consumerType: "Customer",
    walletProvider: walletProvider,
  });
  const [state, setState] = useState({
    pageNumber: 1,
    size: 20,
    startDate: "",
    endDate: "",
    accountNumber: accountNumber,
    consumerType: "Customer",
    walletProvider: walletProvider,
  });

  const {
    data,
    isLoading: isLoadingCustomerWalletTransactions,
    error,
  } = useCustomerWalletTransactions(preState);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const filterData = () => {
    setPreState({ ...state, pageNumber: 1 });
  };

  return (
    <div>
      {error && (
        <p className="alert alert-danger small">
          Error fetching customer wallet transaction
        </p>
      )}
      {!error && (
        <div>
          <div className="card">
            {isLoadingCustomerWalletTransactions ? (
              <div className="d-flex justify-content-center align-items-center">
                <Loader />
              </div>
            ) : (
              <div className="card-body p-3 ">
                <div className="d-flex justify-content-between align-items-center py-3">
                  <form className="d-flex flex-row flex-wrap">
                    <div className="form-group mr-3">
                      <div className="input-group mt-2">
                        <label className="mr-2 mt-2">From </label>
                        <input
                          type="date"
                          name="startDate"
                          className="form-control"
                          value={state.startDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div className="form-group mr-3 mt-2">
                      <div className="input-group">
                        <label className="mr-2 mt-2">To </label>
                        <input
                          type="date"
                          className="form-control"
                          name="endDate"
                          value={state.endDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </div>
                    </div>
                    <div>
                      <button
                        onClick={filterData}
                        className="btn btn-primary btn-sm mt-2"
                        disabled={isLoadingCustomerWalletTransactions}
                      >
                        Search
                      </button>
                    </div>
                  </form>
                </div>
                <h3 className="page-subtitle mb-3 ">
                  Available Balance:{" "}
                  {isLoadingCustomerWalletTransactions ? (
                    <Loader />
                  ) : data?.availableBalance ? (
                    formatMoney(data?.availableBalance, data?.currency)
                  ) : (
                    formatMoney(data?.availableBalance, data?.currency)
                  )}
                </h3>
                <h3 className="page-subtitle mb-3 ">
                  Account Number:{" "}
                  {isLoadingCustomerWalletTransactions ? (
                    <Loader />
                  ) : data?.accountNumber ? (
                    accountNumber
                  ) : (
                    "N/A"
                  )}
                </h3>

                <div className="table-responsive">
                  <table className="table">
                    <thead className="bg-lighter-grey">
                      <tr>
                        <th>S/N</th>
                        <th>Created Date</th>
                        {/* <th>Transaction ID</th> */}
                        {/*<th>Transaction Amount</th>*/}
                        {/*<th>Transaction Type</th>*/}
                        <th>Credit</th>
                        <th>Debit</th>
                        <th>Sender Acct No</th>
                        <th>Recipient Acct No</th>
                        <th>Transaction Status</th>
                        <th>Transaction Charge</th>
                      </tr>
                    </thead>

                    <tbody>
                      {data?.transactions?.length > 0 ? (
                        data?.transactions?.map((request: any, _id: any) => {
                          const {
                            transactionDate,
                            // amount,
                            transactionType,
                            // transactionId,
                            debitAmount,
                            creditAmount,
                            senderAccountNumber,
                            recipientAccountNumber,
                            transactionStatus,
                            transactionCharge,
                          } = request;

                          return (
                            <tr key={_id}>
                              <td>{_id + 1}</td>
                              <td>
                                {moment(transactionDate).format(
                                  "YYYY-MM-D, h:mma",
                                )}
                              </td>
                              {/* <td>{transactionId}</td> */}
                              {/*<td>{formatMoney(amount, data?.currency)}</td>*/}
                              {/*<td>{transactionType}</td>*/}
                              <td>
                                {transactionType.toLowerCase() === "credit" ||
                                transactionType.toLowerCase() === "accrual" ||
                                transactionType.toLowerCase() === "deposit"
                                  ? formatMoney(creditAmount, data?.currency)
                                  : "-"}
                              </td>
                              <td>
                                {transactionType.toLowerCase() === "debit" ||
                                transactionType.toLowerCase() === "withdrawal"
                                  ? formatMoney(debitAmount, data?.currency)
                                  : "-"}
                              </td>
                              <td>{senderAccountNumber ?? "N/A"}</td>
                              <td>{recipientAccountNumber ?? "N/A"}</td>
                              <td>{transactionStatus ?? "N/A"}</td>
                              <td>
                                {formatMoney(transactionCharge, data?.currency)}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <NoTableDataAvailable />
                      )}
                    </tbody>
                  </table>
                </div>
                {data && data?.transactions && (
                  <Paginator
                    size={preState.size}
                    page={preState.pageNumber}
                    count={data?.total}
                    changeCurrentPage={(pageNumber: number) =>
                      setPreState({ ...preState, pageNumber })
                    }
                  />
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerWalletTransactions;
